import React from 'react'

import ReferenceButton from './referenceButton'

const ReferenceIngress =  (props) => {
  return (
    <ReferenceButton {...props} title="Choose Entry">
      {({ handleClick }) => {
        const handleMouseDown = handleClick
        return props.children({ handleMouseDown })
      }}
    </ReferenceButton>
  )
}

export default ReferenceIngress